import React, { useRef, useEffect, useState } from 'react';

import FooterComponent from 'components/FooterComponent';
import HeaderComponent from 'components/HeaderComponent';
import { useHeader } from 'hooks/HeaderContext';

import {
  Container,
  Content,
  ContainerList,
  ItemList,
  Title,
  Delivery,
} from './styles';
import { storeAddresses } from 'mock/storeAddresses';

const StoreAddreess = () => {
  const { handleRef } = useHeader();
  const containerRef = useRef();
  const [urlBack, setUrlBack] = useState('/perfil');

  useEffect(() => {
    handleRef(containerRef);
  }, []);

  return (
    <Container ref={containerRef}>
      <HeaderComponent title="Restaurantes" href={urlBack} />

      <Content>
        {storeAddresses.map(store => (
          <>
            <Title>{store.title}</Title>

            <ContainerList>
              {store.addresses.map((address, index: number) => (
                <ItemList key={index}>
                  <h3>{address.name}</h3>
                  <h5>
                    {address.street}, {address.number}
                  </h5>
                  <h5>
                    {address.district && `${address.district} - `}
                    {address.city}
                  </h5>
                  <h5>{address.zipcode}</h5>

                  {address.delivery && (
                    <Delivery>
                      <h5>Delivery</h5>
                    </Delivery>
                  )}
                </ItemList>
              ))}
            </ContainerList>
          </>
        ))}
      </Content>

      <FooterComponent />
    </Container>
  );
};

export default StoreAddreess;
